import { Provider } from "react-redux";
import { store } from "./store";
import Routes from "./routes";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#444AF6",
    },
    secondary: {
      main: "#200B4C",
    },
    info: {
      main: "#FFF",
    },
  },
});
function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Routes />
      </ThemeProvider>
    </Provider>
  );
}

export default App;
